import { useBiometrics } from './BiometricsContext';
import { HeadingRegular, BodyR, Button } from '@pensionbee/honeypot-ui';
import { ThemedImage } from '@/domains/theme/ThemedImage';

interface BiometricsSetupProps {
  onSuccess: () => void;
}

const BiometricsSetup: React.FC<BiometricsSetupProps> = ({ onSuccess }) => {
  const { enable: enableBiometrics, authenticate } = useBiometrics();

  const handleEnable = async () => {
    await enableBiometrics();
    await authenticate();

    onSuccess();
  };

  const handleDisable = async () => {
    onSuccess();
  };

  return (
    <div className="mx-auto max-w-header min-h-screen flex flex-col px-20 sm:px-28 pt-40 sm:py-32">
      <div className="grid grid-cols-12 flex-grow">
        <div className="col-span-12 md:col-span-6 md:col-start-4 mt-96 flex flex-col">
          <div>
            <div className="pb-28 flex justify-center">
              <ThemedImage
                name="Lock-round-open"
                alt="Lock icon"
                className="w-[120px]"
              />
            </div>

            <div className="pb-20">
              <HeadingRegular as="h1">
                Use biometrics to unlock PensionBee
              </HeadingRegular>
            </div>

            <div className="pb-20">
              <BodyR>
                You won’t need to enter your PIN every time you open the app.
                Using biometrics is fast and secure. This can be changed anytime
                in the &quot;Accounts&quot; tab.
              </BodyR>
            </div>
          </div>
          <div className="mt-auto pb-36 flex flex-col gap-16">
            <Button className="w-full" onClick={handleEnable}>
              Enable Biometrics
            </Button>

            <Button
              variant="secondary"
              className="w-full"
              aria-label="Not now"
              onClick={handleDisable}
            >
              Not now
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BiometricsSetup;
